import React, { memo } from 'react';

import DateFnsUtils from '@date-io/date-fns';
import { ThemeProvider } from '@material-ui/core/styles';
import {
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import ptBR from 'date-fns/locale/pt-BR';
import PropTypes from 'prop-types';
import { IconContext } from 'react-icons';
import { Provider as ReduxProvider } from 'react-redux';
import { Router } from 'react-router-dom';

import { history } from '~/helpers/history-helper';
import store from '~/redux/store';
import materialTheme from '~/theme/index';

const ICON_PROP_VALUE = { className: 'react-icons' };

const Providers = memo(({ children }) => {
    return (
        <ThemeProvider theme={materialTheme}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                <IconContext.Provider value={ICON_PROP_VALUE}>
                    <Router history={history}>
                        <ReduxProvider store={store}>
                            {children}
                        </ReduxProvider>
                    </Router>
                </IconContext.Provider>
            </MuiPickersUtilsProvider>
        </ThemeProvider>
    );
});

Providers.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Providers;
